import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { TasksService } from 'src/app/services/tasks.service';
import { clientErrored } from '../error/error.actions';
import { AppState } from '../reducers';
import * as serviceTaskActions from './service-task.actions';

@Injectable()
export class ServiceTaskEffects {

	constructor(private actions$: Actions, private store: Store<AppState>, private errorService: ErrorService, private tasksService: TasksService) {
	}

	removeTaskRequested$ = createEffect(() =>
		this.actions$.pipe(
			ofType(serviceTaskActions.removeServiceTaskRequested),
			exhaustMap(action => this.tasksService.removeTask(action.taskId, action.recipientId).pipe(
				map(() => serviceTaskActions.removeServiceTaskCompleted()),
				catchError((error: HttpErrorResponse) => of(clientErrored({ toastMessage: 'Remove task failed', errorMessage: this.errorService.getErrorMessage(error) })))
			))
		)
	);
}